export const LS_INVOICING_API_ROOT = '/admin/invoicing/v1';
